import Button from '../../components/Button';
import FeatureCard from '../../components/FeatureCard';
import { ReactComponent as Sparkle } from '../../assets/sparkle.svg';
import transactionsDesktop from '../../assets/images/transactions-desktop.webp';
import borrowingDesktop from '../../assets/images/borrowing-desktop.webp';
import smartContractDesktop from '../../assets/images/smart-contract-desktop.webp';
import perpsDesktop from '../../assets/images/perps-desktop.webp';
import transactionsMobile from '../../assets/images/transactions-mobile.webp';
import borrowingMobile from '../../assets/images/borrowing-mobile.webp';
import smartContractMobile from '../../assets/images/smart-contract-mobile.webp';
import perpsMobile from '../../assets/images/perps-mobile.webp';

export default function KeyFeaturesSection() {
  return (
    <section
      id='key-features'
      className='flex items-center justify-center my-26'
    >
      <div className='w-full max-w-5xl flex flex-col items-center text-center sm:px-6'>
        <Button
          color='outlineGray'
          size='rounded'
          className='pointer-events-none mb-6'
        >
          <Sparkle />
          Key Features
        </Button>
        <div className='space-y-4 mb-12 px-6'>
          <h2 className='text-4.5xl font-semibold leading-[141%]'>
            All your agents, one powerful tool
          </h2>
          <p className='text-white/60 text-lg md:text-base'>
            Revolutionize Your Blockchain Experience with Intelligent AI Agents
          </p>
        </div>

        <div className='w-full space-y-6 sm:space-y-4'>
          <div className='grid grid-cols-1 md:grid-cols-[42fr_58fr] gap-6 sm:gap-4 justify-items-center'>
            <FeatureCard
              title='Transaction AI Agent'
              description='Bridge and Swap (BRAP) seamlessly across chains without worrying about gas.'
              desktopImage={transactionsDesktop}
              mobileImage={transactionsMobile}
              alt='Transaction AI Agent Interface'
            />
            <FeatureCard
              title='Lending & Borrow'
              description='Lend, Borrow, and execute complex on-chain operations with a single natural language command via your AI agent for seamless, secure cross-chain finance.'
              desktopImage={borrowingDesktop}
              mobileImage={borrowingMobile}
              alt='Lending & Borrow Interface'
            />
          </div>
          <div className='grid grid-cols-1 md:grid-cols-[58fr_42fr] gap-6 sm:gap-4 justify-items-center'>
            <FeatureCard
              title='Create Custom Smart Contracts'
              description='Create staking contracts, merge platform strategies into one, and launch your own tokens and NFTs.'
              desktopImage={smartContractDesktop}
              mobileImage={smartContractMobile}
              alt='Smart Contract Creation Interface'
            />
            <FeatureCard
              title='Access to Perpetual Futures & Leverage Products'
              description='Trade Perpetual Futures on Hyperliquid directly via your AI agent for seamless, gas-efficient cross-chain trading.'
              desktopImage={perpsDesktop}
              mobileImage={perpsMobile}
              alt='Perpetual Futures Trading Interface'
            />
          </div>
        </div>
      </div>
    </section>
  );
}
